import {toImportCodeUpper} from "../transformers/shared/normalize-spreadsheet-cell-value";

/**
 * Import order for product warehouse assignment: per part, process warehouse code `00` before others.
 *
 * @param {Array<*|null|undefined>} apiRequests
 * @returns {number[]} Original row indices in execution order
 */
export const getProductWarehouseAssignmentExecutionOrder = (apiRequests) => {
    const length = apiRequests?.length ?? 0;
    const indices = Array.from({length}, (_, i) => i);

    indices.sort((indexA, indexB) => {
        const a = apiRequests[indexA];
        const b = apiRequests[indexB];

        if (a == null && b == null) {
            return indexA - indexB;
        }
        if (a == null) {
            return 1;
        }
        if (b == null) {
            return -1;
        }

        const partA = a.partId != null ? String(a.partId) : '';
        const partB = b.partId != null ? String(b.partId) : '';
        if (partA !== partB) {
            if (!partA) {
                return 1;
            }
            if (!partB) {
                return -1;
            }
            return partA.localeCompare(partB);
        }

        const codeA = toImportCodeUpper(a.warehouseCode);
        const codeB = toImportCodeUpper(b.warehouseCode);
        const rankA = codeA === '00' ? 0 : 1;
        const rankB = codeB === '00' ? 0 : 1;
        if (rankA !== rankB) {
            return rankA - rankB;
        }

        return indexA - indexB;
    });

    return indices;
};
